import { customBaseQuery } from '@/lib/baseQuery';
import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiResponse } from '@/shared/types';

/** The relay's last extraction run; it only knows about runs it started itself, not the Monday schedule. */
export interface ExtractContentStatus {
  ok: boolean;
  running: boolean;
  pid: number | null;
  started_time: string | null;
  /** null while running or before any run; 0 on success, 1 when main.py caught an error. */
  exit_code: number | null;
}

export const extractContentApi = createApi({
  reducerPath: 'extractContentApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    runExtractContent: builder.mutation<ExtractContentStatus, void>({
      query: () => ({ url: 'v1/extract-content/run', method: 'POST' }),
      transformResponse: (res: ApiResponse<ExtractContentStatus>) => res.data,
    }),
    getExtractContentStatus: builder.query<ExtractContentStatus, void>({
      query: () => ({ url: 'v1/extract-content/status', method: 'GET' }),
      transformResponse: (res: ApiResponse<ExtractContentStatus>) => res.data,
    }),
  }),
});

export const { useRunExtractContentMutation, useGetExtractContentStatusQuery } =
  extractContentApi;
